import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import LogoAnimation from 'components/desktop/_general/LogoAnimation/LogoAnimation';
import 'containers/desktop/User/PasswordRecovery/PasswordRecovery.scss';

const LinkSentConfirmation = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const renderContent = () => {
		return (
			<>
				<section>
					<div className="wave">
						<span></span>
						<span></span>
						<span></span>
					</div>
					<div>
						<Card className="forgot-password-inner-container">
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
								}}
							>
								<div style={{ transform: 'scale(0.8)', transformOrigin: 'center' }}>
									<LogoAnimation />
								</div>
								<span
									style={{
										color: '#6066C1',
										fontWeight: 'bold',
										fontSize: '1rem',
									}}
								>
									Artificial Intelligence Recipes
								</span>
							</div>

							<Card.Body className="forgot-password-inner-container-div">
								<div className="forgot-password-form">
									<h2>{t('user:LINK_SENT_TITLE')}</h2>
									<p>{t('user:LINK_SENT_TEXT')}</p>
									<div className="d-grid gap-2 mt-3">
										<button
											type="button"
											className="btn btn-outline-secondary"
											onClick={() => navigate('/login')}
										>
											{t('user:BACK_TO_LOGIN')}
										</button>
									</div>
								</div>
							</Card.Body>
						</Card>
					</div>
				</section>
			</>
		);
	};

	return <>{renderContent()}</>;
};

export default LinkSentConfirmation;
